import resources from "@/providers/resources";
const actions = {
  clearData(context) {
    context.commit("setUserData", {});
    context.commit("setUser", null);
  },
  toggleSidebar(context, payload) {
    context.commit("toggleSidebar", payload);
  },
  setUserData(context, payload) {
    context.commit("setUserData", payload);
  },
  setNotificationsCount(context, payload) {
    context.commit("setNotificationsCount", payload);
  },
  getDatasets(context) {
    resources.catalog
      .get()
      .then((data) => {
        context.commit("setDatasets", data);
      })
      .catch((e) => {
        console.log(e);
      });
  },
};

export default actions;
